import { max } from 'd3-array';
import { scaleBand } from 'd3-scale';
import { axisBottom } from 'd3-axis';
import { linearAxis } from '../../../factory/axes';

export default function (props, rawData = {}) {
  const { initialWidth, isMobile } = props;

  const margins = {
    top: 8,
    right: isMobile ? 10 : 30,
    bottom: isMobile ? 42 : 25,
    left: 35,
  };

  const chartHeight = isMobile
    ? Math.round(initialWidth * 0.65)
    : Math.round(initialWidth * 0.35);

  const width = initialWidth - margins.right - margins.left;
  const height = chartHeight - margins.top - margins.bottom;

  const filtered = (rawData.years || [])
    .filter(d => Number(d.maxMag) >= 6)
    .map(d => ({
      ...d,
      year: String(d.year),
      count: Number(d.mag6Count) || 0,
    }))
    .sort((a, b) => Number(a.year) - Number(b.year));

  const chartData = filtered;
  const x = scaleBand()
    .range([0, width])
    .domain(chartData.map(d => d.year))
    .paddingInner(0.15);
  const xAxis = axisBottom;

  const yMax = max(chartData, d => d.count) || 1;

  const { axis: yAxis, scale: y } = linearAxis({
    orientation: 'left',
    range: [height, 0],
    domain: [0, Math.max(yMax, 250)],
    nice: false,
  });

  return {
    chartData,
    y,
    yAxis,
    height,
    x,
    xAxis,
    width,
    margins,
    isMobile,
  };
}
